import {formateData, headers,bodyHeader} from "./index";
import *as utils from '../utils'
import {applicationName} from "../utils";

let host="/cm-sites-pms/";
 let Apis={
     likeListById:host+'weibo/likeListById',//获取点赞列表
     getCommentsByWeiboId:host+'weibo/getCommentsByWeiboId',//获取评论
     createComment:host+'weibo/createComment',//微博体评论
     delComment:host+'weibo/delComment',//删除微博
     replyComment:host+'weibo/replyComment',//回复评论
     location:host+'weibo/location',//地图查询
     hotTopic:host+'weibo/hotTopic',//话题
     seachUser:host+'weibo/seachUser',//获取@列表
     getWeiboMessageList:host+'weibo/getWeiboMessageList',//微博私信功能开发
     replyMsg:host+'weibo/replyMsg',//微博私信回复
     getWeiboMessageDetail:host+'weibo/getWeiboMessageDetail',//微博私信回复
     getRepostListById:host+'weibo/repostListById',//获取微博分享列表
 };
export const saveWeibo = (id, content, mediaCode, picUrlsStr, tagsStr,statusName,taskPublishDate=null,touTiaoArticle=null, callBack)=> {
    let url = "/cm-sites-pms/weibo/save?picUrlsStr=" + picUrlsStr + "&tagsStr=" + tagsStr;
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: {
            ...headers,
            "Content-Type" : 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({id, content, mediaCode, picUrlsStr, tagsStr, statusName,taskPublishDate,touTiaoArticle})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:saveWeibo",error);
        callBack([]);
    })
};

export const getWeiboByWeiboId = (weiboId, callBack)=> {
    let url = "/cm-sites-pms/weibo/show";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({weiboId})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:saveWeibo",error);
        callBack("");
    })
};


/**
 * 更新微博的状态
 * @param params
 * @param callBack
 */
export const saveStatusName = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/weibo/saveStatusName";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:saveStatusName",error);
        callBack("");
    })
};

/**
 * 批量获取指定微博的转发数评论数喜欢数
 * @param params
 * @param callBack
 */
export const getCounts = (mediaCode, ids, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/weibo/getCounts";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({mediaCode, ids})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getCounts",error);
        callBack("");
    })
};

/**
 * 获取当前登录用户的信息
 * @param params
 * @param callBack
 */
export const getUserInfo = (mediaCode, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/weibo/getUserInfo";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({mediaCode})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getUserInfo",error);
        callBack("");
    })
};

/**
 * 删除一条本地自己发的微博
 * @param params
 * @param callBack
 */
export const deleteWeibo = (id, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/weibo/deleteWeibo";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({id})
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getDeleteInfo",error);
        callBack("");
    })
};

/**
 * 撤稿一条微博
 * @param params
 * @param callBack
 */
export const getRevokeWeibo = (mediaCode, weiboMid, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/weibo/getDeleteInfo";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({mediaCode, weiboId:weiboMid})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getDeleteInfo",error);
        callBack("");
    })
};

/**
 * 获取待我审核素材列表
 * @param start
 * @param size
 * @param tabType
 * @param mediaCode
 * @param callBack
 */
export const getTodoListList = (params, callBack)=> {
    let url = "/cm-sites-activiti/activiti/getNeedProcessed";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            ...headers,
            userName: window.userAccount,
            'Content-Type': 'application/json; charset=UTF-8'
        },
        credentials: 'include',
        body: JSON.stringify(params)
    }).then(response => response.json()).then(data => {
        if(data.data)
        {
            let ids = [];
            (data.data).map(weiboObject=>
            {
                let weibo = weiboObject.data;
                ids.push(weibo.id);
            })
            getWeiboListByIds(ids,(dataArray)=>{
                if(dataArray);
                {
                    callBack(dataArray);
                }
            });
        }
    }).catch((error) => {
        console.error("actionError:getTodoListList",error);
        callBack([]);
    })
};

export const getWeiboListByIds = (ids, callBack)=> {
    let url = "/cm-sites-pms/weibo/getWeiboListByIds";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            ...headers
        },
        credentials: 'include',
        body: formateData({ids})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getWeiboListByTodoList",error);
        callBack([]);
    })
};

/**
 * 获取已审核素材列表
 * @param params
 * @param callBack
 */
export const getExaminedList = (params, callBack)=> {
    let url = "/cm-sites-activiti/activiti/examined";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            ...headers,
            userName: window.userAccount,
            'Content-Type': 'application/json; charset=UTF-8'
        },
        credentials: 'include',
        body: JSON.stringify(params)
    }).then(response => response.json()).then(data => {
        if(data.data)
        {
            let ids = [];
            (data.data).map(weibo=>
            {
                ids.push(weibo.data.id);
            })
            getWeiboListByIds(ids,(dataArray)=>{
                if(dataArray);
                {
                    callBack(dataArray);
                }
            });
        }
    }).catch((error) => {
        console.error("actionError:getExaminedList",error);
        callBack([]);
    })
};

// 检查头条文章中资源是否是融媒体系统地址
export const checkContent = (content, callBack)=> {
    let url = "/cm-sites-pms/storyNew/checkFileValid";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({content})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:publishWeibo",error);
        callBack("");
    })
};

export const publishWeibo = (reqDto, callBack)=> {
    let url = "/cm-sites-pms/weibo/publish";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({reqDto})
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:publishWeibo",error);
        callBack("");
    })
};

///获取点赞数
export function getLikeListById(body, callBack) {
    let url = Apis.likeListById + utils.params(body);
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getLikeListById", error);
        callBack({});
    })
}

///获取评论。
export function getCommentsByWeiboId(body, callBack) {
    let url = Apis.getCommentsByWeiboId + utils.params(body);
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getCommentsByWeiboId", error);
        callBack({});
    })
}
///微博体评论。
export function createComment(body, callBack) {
    let url = Apis.createComment;
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        body:JSON.stringify(body),
        headers: bodyHeader,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:createComment", error);
        callBack({});
    })
}
///删除微博评论。
export function delComment(body, callBack) {
    let url = Apis.delComment + utils.params(body);
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:delComment", error);
        callBack({});
    })
}

///回复评论。
export function replyComment(body, callBack) {
    let url = Apis.replyComment;
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: bodyHeader,
        body:JSON.stringify(body),
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:replyComment", error);
        callBack({});
    })
}

///获取地图
export function location(body, callBack) {
    let url = Apis.location + utils.params(body);
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:location", error);
        callBack({});
    })
}

///获取话题
export function hotTopic(body, callBack) {
    let url = Apis.hotTopic + utils.params(body);
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:hotTopic", error);
        callBack({});
    })
}

///获取@列表
export function seachUser(body, callBack) {
    let url = Apis.seachUser + utils.params(body);
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:seachUser ", error);
        callBack({});
    })
}

///获取微博私信用户列表
export function getWeiboMessageList(body, callBack) {
    let url = Apis.getWeiboMessageList + utils.params(body);
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getWeiboMessageList ", error);
        callBack({});
    })
}

///微博私信回复功能
export function replyMsg(body, callBack) {
    let url = Apis.replyMsg + utils.params(body);
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:replyMsg ", error);
        callBack({});
    })
}

///微博消息详情
export function getWeiboMessageDetail(body, callBack) {
    let url = Apis.getWeiboMessageDetail + utils.params(body);
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getWeiboMessageDetail ", error);
        callBack({});
    })
}

///获取微博分享列表；
export function getRepostListById(body, callBack) {
    let url = Apis.getRepostListById + utils.params(body);
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getRepostListById ", error);
        callBack({});
    })
}